import React, { useState, useEffect } from "react";
import { auth, db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";
import { useParams, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, Pill, Settings, LogOut, ClipboardList } from "lucide-react";
import PatientHistory from "./PatientHistory"; // Import the new file
import { History } from "lucide-react";
// Intha components-ai namba thonniya create panna porom
import RegisterPatient from "./RegisterPatient";
import PatientList from "./PatientList";
import MedicineStock from "./MedicineStock";

const HospitalDashboard = () => {
  const { hospitalName } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("overview");
  const [hospitalInfo, setHospitalInfo] = useState(null);

  useEffect(() => {
    const fetchInfo = async () => {
      const user = auth.currentUser;
      if (user) {
        const docSnap = await getDoc(doc(db, "hospitals", user.uid));
        if (docSnap.exists()) setHospitalInfo(docSnap.data());
      }
    };
    fetchInfo();
  }, []);

  const renderContent = () => {
    switch (activeTab) {
      case "register": return <RegisterPatient />;
      case "patients": return <PatientList />;
      case "history": return <PatientHistory />;
   
      case "overview": return <div className="p-10 bg-white rounded-3xl border border-slate-100 italic text-slate-400">Overview content coming soon...</div>;
      default: return <div className="p-10 italic text-slate-400">Select an option from sidebar</div>;
    }
  };

  return (
    <div className="flex h-screen bg-[#F8FAFC]">
      <aside className="w-72 bg-white border-r border-slate-100 flex flex-col p-6">
        <div className="flex items-center gap-2 mb-10 px-2 font-black text-xl text-slate-800 tracking-tight">
           <div className="h-8 w-8 bg-blue-600 rounded-lg flex items-center justify-center text-white text-sm">A</div>
           Avaami<span className="text-blue-600">op</span>
        </div>

        <nav className="flex-1 space-y-2">
          {[
            { id: "overview", label: "Dashboard Overview", icon: <LayoutDashboard size={20}/> },
            { id: "register", label: "New Registration", icon: <Users size={20}/> },
            { id: "patients", label: "Outpatients List", icon: <ClipboardList size={20}/> },
            { id: "history", label: "Patient History", icon: <History size={20}/> }, // New Sidebar Button
           
            { id: "settings", label: "Portal Settings", icon: <Settings size={20}/> },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => setActiveTab(item.id)}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-2xl font-bold text-sm transition-all ${
                activeTab === item.id ? "bg-blue-600 text-white shadow-lg shadow-blue-100" : "text-slate-400 hover:bg-slate-50"
              }`}
            >
              {item.icon} {item.label}
            </button>
          ))}
        </nav>

        <button onClick={() => { auth.signOut(); navigate("/login"); }} className="flex items-center gap-3 px-4 py-3 text-red-500 font-bold text-sm hover:bg-red-50 rounded-2xl">
          <LogOut size={20}/> Logout
        </button>
      </aside>

      <main className="flex-1 overflow-y-auto p-10 bg-slate-50/30">
       
        {renderContent()}
      </main>
    </div>
  );
};

export default HospitalDashboard;